module.exports = __webpack_public_path__ + "static/media/07_profile_picture.0d26a7b5.png";